"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  '/': 'Home',
  '/account': 'Login',
  '/fleet': 'Car listing',
  '/driver/[quoteId]': 'Driver',
  '/payment/[quoteId]': 'Payment',
  '/confirm/[refId]': 'Booking Confirmation',
  '/bookings': 'My Bookings',
  '/bookings/[refId]': 'Booking Details',
  '/payment/processing/[quoteId]': 'Payment',
  '/payment/status/[quoteId]': 'Payment',
  '/payment/quickpay/[trackId]': 'Payment',
  '/payment/quickpay/payment/[trackId]': 'Payment',
  '/payment/quickpay/processing/[trackId]': 'Payment',
  '/payment/quickpay/status/[trackId]': 'Payment',
  '/account/email': 'Login',
  '/offers': 'Offers',
  '/extendBooking/[refId]': 'Extend Booking',
  '/car-rental': 'Car Rental Index Page',
  '/car-rental/cities': 'City Index Page',
  '/car-rental/cities/[slug]': 'City Listing Page',
  '/car-rental/airports': 'Airport Index Page',
  '/car-rental/airports/[slug]': 'Airport Listing Page',
  '/car-rental/cities/branches': 'City Branch Index Page',
  '/car-rental/cities/branches/[slug]': 'City Branch Listing Page'
};